import { SPONSORSHIP_URL, GENESIS_APPLY_URL, GUILD_DOMAIN } from 'src/utilities/envConfig';
import { basename as infrastructureBasename } from '@guildeducationinc/frontend-infrastructure';
import { ProgramData } from '@src/typings/mfeCatalogTools';

export const applyLink = (offering, baseUrl = GENESIS_APPLY_URL): string => {
	return `${baseUrl}/${offering.uuid}`;
};

export const basename = infrastructureBasename({ path: '/' });

export const buEligibility = `https://benefits.${GUILD_DOMAIN}/eligibility`;

export const generateProgramDetailsRequirementLink = (program: ProgramData) => {
	return `/programs/${program.id}#detail-requirements`;
};

export const institutionImageLink = informalName =>
	`https://recess-images.guildeducation.com/learning_partner_institution_photos/${informalName}.jpg`;

export const generateSponsorshipApplyLink = uuid => `${SPONSORSHIP_URL}/?institution_id=${uuid}`;

export const getUpdatedURL = () => {
	const parts = location.host.split('.');
	const isLegacySubdomain = parts.length === 3 && parts[0] !== 'catalog';
	const prAppSubdomainRegex = /pr-\d+-catalog-frontend/i;
	const isPrApp = prAppSubdomainRegex.test(parts[0]);
	const hasCatalogPathname = location.pathname.includes('/catalog');
	const oldPathname = location.pathname;
	const newPathname = oldPathname.replace('/catalog', '');

	// legacy subdomain - https://chipotle.guildeducation.com/catalog,
	if (isLegacySubdomain && !isPrApp) {
		const newHost = `catalog.${GUILD_DOMAIN}`;
		return `${location.protocol}//${newHost}${newPathname}${location.search}`;
	}

	// https://catalog.guildeducation.com/catalog the last /catalog is being removed
	if (hasCatalogPathname) {
		return `${location.protocol}//${location.host}${newPathname}${location.search}`;
	}
	return null;
};
